import { Button, DatePicker, Flex, Space } from "antd";
import { CardContainer } from "components/elements";
import EmployeeSalaryOvertimeTable from "components/table/EmployeeSalaryOvertimeTable";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import localeTh from 'antd/es/date-picker/locale/th_TH';
import localeEn from 'antd/es/date-picker/locale/en_US';

function EmployeeSalaryOvertime({
  pagination = {},
  isLoading = false,
  employeeOvertimeList = [],
  onChange = () => { },
  handleDateChange = () => { },
  handleApply = () => { }
}) {
  const { t, i18n } = useTranslation();
  const { RangePicker } = DatePicker;

  function localeFn() {
    if (i18n.language === 'en') {
      return localeEn
    } else {
      return {
        ...localeTh,
        lang: {
          ...localeTh.lang,
          yearFormat: "BBBB",
          dateFormat: "D/M/BBBB",
          cellYearFormat: "BBBB"
        }
      }
    }
  }

  return (
    <Space direction="vertical" size={24} style={{ width: "100%" }}>
      <Flex gap={16} align="end">
        <Flex vertical>
          <label>{t("start-date-to-end-date")}</label>
          <RangePicker
            name="employedStartDate"
            placeholder={[t("start-date-to-end-date"), ""]}
            defaultValue={[dayjs().startOf('month'), dayjs()]}
            format={i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB"}
            onChange={handleDateChange}
            disabledDate={(currentDate) => currentDate.isBefore(dayjs("2024-01-01"))}
            size="large"
            locale={localeFn()}
          />
        </Flex>

        <Button type="primary"
          style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" }} size="large" onClick={handleApply}>
          {t("translation.search")}
        </Button>
      </Flex>

      <EmployeeSalaryOvertimeTable
        isLoading={isLoading}
        dataSource={employeeOvertimeList}
        pagination={pagination}
        onChange={onChange}
      />
    </Space>
  );
}

export default EmployeeSalaryOvertime;
